// RotatedMarker.js
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useRef } from 'react';

function RotatedMarker({ position, rotationAngle, popupText }) {
  const markerRef = useRef();

  useEffect(() => {
    if (markerRef.current) {
      const icon = markerRef.current._icon;
      if (icon) {
        icon.style.transform = `rotate(${rotationAngle}deg)`;
        icon.style.transformOrigin = 'center';
      }
    }
  }, [rotationAngle]);

  const customIcon = new L.Icon({
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  return (
    <Marker
      position={position}
      icon={customIcon}
      ref={(ref) => {
        markerRef.current = ref?.leafletElement || ref;
      }}
    >
      {popupText}
    </Marker>
  );
}

export default RotatedMarker;
